class ApiClient {
  constructor() {
    // Use relative URLs since frontend and backend are on same origin
    this.baseURL = '/api';
    this.csrfToken = null;
    this.sessionId = null;
  }

  /**
   * Get CSRF token from backend
   */
  async getCsrfToken() {
    try {
      const response = await fetch(`${this.baseURL}/get-csrf-token.php`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.csrfToken = data.csrf_token;
      return data;
    } catch (error) {
      console.error('Error getting CSRF token:', error);
      throw error;
    }
  }

  /**
   * Submit survey data to backend
   */
  async submitSurvey(formData) {
    try {
      // Get CSRF token if we don't have one
      if (!this.csrfToken) {
        await this.getCsrfToken();
      }

      const payload = {
        ...formData,
        csrf_token: this.csrfToken
      };

      const response = await fetch(`${this.baseURL}/formsave.php`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      // Clear token after successful submission (one-time use)
      this.csrfToken = null;
      
      return result;
    } catch (error) {
      console.error('Error submitting survey:', error);
      
      // If CSRF token is invalid, try to get a new one
      if (error.message.includes('CSRF') || error.message.includes('403')) {
        this.csrfToken = null;
      }
      
      throw error;
    }
  }

  /**
   * Test API connection
   */
  async testConnection() {
    try {
      const response = await fetch(`${this.baseURL}/get-csrf-token.php`, {
        method: 'GET',
        credentials: 'include',
      });
      return response.ok;
    } catch (error) {
      console.error('API connection test failed:', error);
      return false;
    }
  }
}

// Export singleton instance
export default new ApiClient();
